// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root[data-v-b7e72a84] .v-application--wrap{min-height:inherit}.mono[data-v-b7e72a84]{font-family:monospace}.link[data-v-b7e72a84]{font-family:monospace;color:#0099fd}.link[data-v-b7e72a84]:hover{font-family:monospace;color:#007aca}.offline-reason[data-v-b7e72a84]{white-space:pre-wrap}", ""]);
// Exports
module.exports = exports;
